import { useState } from "react";
import { Button } from "react-bootstrap";
import {
  BsFillBarChartLineFill,
  BsPauseFill,
  BsPlayFill,
} from "react-icons/bs";
import { ChallengeModal, EditTimeModal, GroupTable, PauseModal } from "./index";
import { defaultRounds } from "../utils/activity";

import {
  defaultAmbulanceDiversionsCost,
  defaultAmbulanceDiversionsError,
  defaultArrivalsWaitingCost,
  defaultArrivalsWaitingError,
  defaultExtraStaffCost,
  defaultExtraStaffError,
  defaultHoursNotComplete,
  defaultHoursNotCompleteCost,
  defaultPatientsWaitingCost,
  defaultPatientsWaitingError,
  defaultRequestWaitingError,
} from "../utils/activity";
import { useNavigate } from "react-router-dom";
import { encrypt } from "../utils/crypto";
import { table } from "../utils/constant";

function Group({ sessionData, teamData, socket }) {
  const [show, setShow] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [challengeModal, setChallengeModal] = useState(false);
  const nevigate = useNavigate();

  let isGameComplete = sessionData?.session?.is_game_complete
    ? sessionData?.session?.is_game_complete === 1
    : false;

  let isGameStart =
    teamData?.length && teamData?.every((team) => team.current_status >= 3);
  const editModalShow = () => {
    setEditModal(!editModal);
  };
  const challengeModalShow = () => {
    setChallengeModal(!challengeModal);
  };

  const countQualityErrors = (
    gameData,
    current_round,
    game_complete_status,
    index,
  ) => {
    // ACTIVITY
    let ambulanceDiversionsActivity = 0;
    let patientsWaitingActivity = 0;
    let arrivalsWaitingActivity = 0;
    let requestWaitingActivity = 0;
    let extraStaffActivity = 0;

    if (!gameData) {
      return {
        activity: {
          ambulanceDiversionsActivity,
          patientsWaitingActivity,
          arrivalsWaitingActivity,
          requestWaitingActivity,
          extraStaffActivity,
        },
        teamCost: 0,
        teamQualityError: 0,
      };
    }
    // QUALITY ERRORS
    let ambulanceDiversions = 0;
    let patientsWaiting = 0;
    let arrivalsWaiting = 0;
    let requestWaiting = 0;
    let extraStaff = 0;
    let noOfHoursNotComplete = 0;

    // COST
    let ambulanceDiversionsCost = 0;
    let patientsWaitingCost = 0;
    let arrivalsWaitingCost = 0;
    let extraStaffCost = 0;
    let noOfHoursNotCompleteCost = 0;
    const isGames = gameData.length > 0;
    if (isGames) {
      for (const data of gameData) {
        const isIFTrue =
          sessionData?.session?.is_game_complete === 1
            ? true
            : data && data?.round_no !== current_round;
        if (isIFTrue) {
          // ACTIVITY
          const totalRequestWaiting = [
            "coming_from_emergency",
            "coming_from_critical",
            "coming_from_surgery",
          ].reduce(
            (sum, key) =>
              sum +
              (data?.[key]?.filter((waiting) => waiting.status === 1)?.length ||
                0),
            0,
          );
          ambulanceDiversionsActivity +=
            Number(data?.ambulance_diversions_count) || 0;
          patientsWaitingActivity += Number(data?.patients_waiting_count) || 0;
          arrivalsWaitingActivity +=
            (data?.role_id !== 1 &&
              Number(data?.data?.walking?.patient_count)) ||
            0;
          requestWaitingActivity += Number(totalRequestWaiting) || 0;
          extraStaffActivity += Number(data.total_extra_staff) || 0;

          if (data?.role_id === 1) {
            // QUALITY ERRORS
            ambulanceDiversions +=
              Number(data?.ambulance_diversions_count) *
                defaultAmbulanceDiversionsError || 0;
            patientsWaiting +=
              Number(data?.patients_waiting_count) *
                defaultPatientsWaitingError || 0;
            // COST
            ambulanceDiversionsCost +=
              Number(data?.ambulance_diversions_count) *
                defaultAmbulanceDiversionsCost || 0;
            patientsWaitingCost +=
              Number(data?.patients_waiting_count) *
                defaultPatientsWaitingCost || 0;
          } else {
            // QUALITY ERRORS
            arrivalsWaiting +=
              Number(data?.data?.walking?.patient_count) *
              defaultArrivalsWaitingError;
            requestWaiting +=
              Number(totalRequestWaiting) * defaultRequestWaitingError;
            // COST
            arrivalsWaitingCost +=
              (data?.role_id !== 1 &&
                Number(data?.data?.walking?.patient_count)) *
              defaultArrivalsWaitingCost;
          }
          extraStaffCost +=
            Number(data.total_extra_staff) * defaultExtraStaffCost;
          extraStaff += Number(data.total_extra_staff) * defaultExtraStaffError;
        }
      }
    }

    if (current_round > 1) {
      // if rounds is 24 then no need calculation
      let notCompletedRounds = 0;
      const isTimesComplete = game_complete_status === "times-complete";
      const is_game_complete = teamData[index]?.is_game_complete;
      if (!isTimesComplete) {
        notCompletedRounds = 0;
      } else if (isTimesComplete && is_game_complete) {
        notCompletedRounds = defaultRounds - current_round;
      }
      noOfHoursNotComplete += notCompletedRounds * defaultHoursNotComplete;
      noOfHoursNotCompleteCost +=
        notCompletedRounds * defaultHoursNotCompleteCost;
    }
    const teamQualityError =
      ambulanceDiversions +
      patientsWaiting +
      arrivalsWaiting +
      requestWaiting +
      extraStaff +
      noOfHoursNotComplete;
    const teamCost =
      ambulanceDiversionsCost +
      patientsWaitingCost +
      arrivalsWaitingCost +
      extraStaffCost +
      noOfHoursNotCompleteCost;
    // ACTIVITY
    let activity = {
      ambulanceDiversionsActivity,
      patientsWaitingActivity,
      arrivalsWaitingActivity,
      requestWaitingActivity,
      extraStaffActivity,
    };

    return { activity, teamCost, teamQualityError };
  };

  const handleTeamPerform = () => {
    nevigate(`/teams-performance/${encrypt(String(sessionData?.session?.id))}`);
  };

  let is_pause = sessionData?.session?.is_game_pause;

  const handlePause = async (type) => {
    const isGameOngoing =
      sessionData?.session?.game_start_time !== null &&
      sessionData?.session?.is_game_complete === 0;

    if (!socket) {
      console.error("Socket connection is not available.");
      return;
    }

    if (type === "pause_game" && isGameOngoing) {
      try {
        socket.emit(
          "game-timer-play-resume",
          {
            session: sessionData,
            teamData: teamData,
            type: type,
          },
          (response) => {
            if (response && response.status === 200) {
              setShow((prev) => !prev);
              is_pause = true;
            } else {
              console.error(
                "Failed to pause game:",
                response?.message || "Unknown error",
              );
            }
          },
        );
      } catch (error) {
        console.error("Error pausing game:", error);
      }
    } else if (isGameOngoing) {
      try {
        socket.emit(
          "game-timer-play-resume",
          {
            session: sessionData,
            teamData: teamData,
            type: type,
          },
          (response) => {
            if (response && response.status === 200) {
              is_pause = false;
            } else {
              console.error(
                "Failed to resume game:",
                response?.message || "Unknown error",
              );
            }
          },
        );
      } catch (error) {
        console.error("Error resuming game:", error);
      }
    }
  };

  let isDisabled = false;
  const getTeamStatus = teamData?.every((item) => item.current_status > 4);
  if (getTeamStatus) {
    if (sessionData?.session?.orientation_video_start && isGameComplete) {
      isDisabled = true;
    }
  } else {
    isDisabled = true;
  }
  const isPracticeRun = !!sessionData?.session?.is_practice_run;
  return (
    <>
      <div className="hstack flex-wrap gap-3 mb-6">
        <Button
          disabled={isDisabled || isPracticeRun}
          variant="outline-primary"
          onMouseDown={(e) => {
            if (e.button === 0) {
              e.preventDefault();
              !is_pause ? setShow((prev) => !prev) : handlePause("resume_game");
            }
          }}
          onClick={(e) => e.preventDefault()}
        >
          {!is_pause ? (
            <span>
              <BsPauseFill className="me-1 mt-n1 text-lg" /> Pause Countdown
            </span>
          ) : (
            <>
              <BsPlayFill className="me-1 mt-n1 text-lg" /> Resume Countdown
            </>
          )}
        </Button>
        {isGameComplete && !isPracticeRun && (
          <Button onClick={handleTeamPerform} variant="outline-primary">
            <BsFillBarChartLineFill className="me-2 mt-n1" />
            {table?.teamPerformance}
          </Button>
        )}
      </div>
      <GroupTable
        teamData={teamData}
        countQualityErrors={countQualityErrors}
        isGameComplete={isGameComplete}
        isGameStart={isGameStart}
        sessionData={sessionData}
        isPracticeRun={isPracticeRun}
      />
      {show && (
        <PauseModal
          show={show}
          hide={() => setShow((prev) => !prev)}
          handlePause={() => handlePause("pause_game")}
        />
      )}
      {editModal && (
        <EditTimeModal show={editModal} hide={() => editModalShow()} />
      )}
      {challengeModal && (
        <ChallengeModal show={true} hide={() => challengeModalShow()} />
      )}
    </>
  );
}
export default Group;
